
import React, { useState, useEffect, useRef } from "react";
/* CSS */
import "../../assets/css/HomePage.css";

/* Background */
import bannerImg from "../../assets/img/new-home/testimonial-banner.png";
/* Icons – Featured Apps */
import aichatIcon from "../../assets/img/new-home/img-icon1.png";
import XRayAnalyzeIcon from "../../assets/img/new-home/img-icon3.png";
import calendarIcon from "../../assets/img/new-home/img-icon4.png";
import treatmentIcons from "../../assets/img/new-home/img-icon5.png";
import claimsIcon from "../../assets/img/new-home/img-icon2.png";
import notesIcon from "../../assets/img/new-home/img-icon6.png";
import diagnosticIcons from "../../assets/img/new-home/img-icon7.png";
import analyticsIcon from "../../assets/img/new-home/img-icon8.png";

/* Icons – AI Solutions */
import patientIcon from "../../assets/img/new-home/icon-1.png";
import diagnosticIcon from "../../assets/img/new-home/icon-2.png";
import practiceIcon2 from "../../assets/img/new-home/icon-3.png";
import treatmentIcon from "../../assets/img/new-home/icon-4.png";
import automationIcon from "../../assets/img/new-home/icon-5.png";
import insuranceIcon from "../../assets/img/new-home/icon-6.png";
import imagingIcon from "../../assets/img/new-home/icon-7.png";
import documentationIcon from "../../assets/img/new-home/icon-8.png";


// App screenshots
import app1 from "../../assets/img/new-home/ban-img-1.png";
import app2 from "../../assets/img/new-home/ban-img-2.png";
import app3 from "../../assets/img/new-home/ban-img-3.png";
import app4 from "../../assets/img/new-home/ban-img-4.png";
import app5 from "../../assets/img/new-home/ban-img-5.png";
import app6 from "../../assets/img/new-home/ban-img-6.png";
import app7 from "../../assets/img/new-home/ban-img-7.png";
// MarketplaceSearch
import { useNavigate } from "react-router-dom";
import MarketplaceSearch from "../../components/marketplace/MarketplaceSearch";
import { useProfile } from "../../contexts/ProfileContext";

const appImages = [app1, app2, app3, app4];
const appImagesAlt = [app5, app6, app7];
const testimonials = [
  {
    name: "Dr. Sarah Chen",
    role: "General Dentist, Chen Dental Care",
    text:
      "The AI diagnostic assistant has transformed how we analyze X-rays. We can now provide faster, more accurate diagnoses, which our patients really appreciate.",
  },
  {
    name: "Dr. Michael Ross",
    role: "Oral Surgeon",
    text:
      "Dentulu’s AI tools significantly reduced our documentation time and improved consistency.",
  },
  {
    name: "Emily Carter",
    role: "Practice Manager",
    text:
      "Scheduling automation alone has improved patient flow and reduced no-shows.",
  },
  {
    name: "James Patel",
    role: "Dental Developer",
    text:
      "The API integrations are clean, scalable, and well-documented.",
  },
  {
    name: "Sophia Martinez",
    role: "Orthodontist",
    text:
      "Treatment planning has never been this efficient and visual.",
  },
  {
    name: "Daniel Kim",
    role: "Dental Consultant",
    text:
      "AI-powered insights help clinics grow with confidence.",
  }
];

/* ---------- DATA ---------- */

const featuredApps = [
  {
    title: "DentalAI Assistant",
    subtitle: "Patient Communication",
    tag: "Popular",
    rating: "4.8",
    img: aichatIcon,
    desc: "AI-powered patient communication and reminders.",
  },
  {
    title: "X-Ray Analyzer Pro",
    subtitle: "Imaging & Analysis",
    tag: "Top Rated",
    rating: "4.8",
    img: XRayAnalyzeIcon,
    desc: "AI-powered dental imaging analysis for accurate diagnostics.",
  },
  {
    title: "SmartScheduler",
    subtitle: "Patient Communication",
    tag: "Popular",
    rating: "4.7",
    img: calendarIcon,
    desc: "Smart scheduling system optimizes bookings and cuts no-shows.",
  },
  {
    title: "Treatment Planner AI",
    subtitle: "Treatment Planning",
    tag: "Popular",
    rating: "4.7",
    img: treatmentIcons,
    desc: "Create comprehensive treatment plans with AI-assisted recommendations",
  },
  {
    title: "Insurance Claims AI",
    subtitle: "Insurance & Billing",
    tag: "Popular",
    rating: "4.6",
    img: claimsIcon,
    desc: "Automate insurance claims processing and reduce rejection rates",
  },
  {
    title: "Clinical Notes",
    subtitle: "Clinical Documentation",
    tag: "Top Rated",
    rating: "4.8",
    img: notesIcon,
    desc: "Generate accurate clinical notes from voice recordings using AI",
  },
  {
    title: "AI Diagnostic Assistant",
    subtitle: "Diagnostic Assistance",
    tag: "Top Rated",
    rating: "4.8",
    img: diagnosticIcons,
    desc: "Real-time diagnostic support with pattern recognition and decision support",
  },
  {
    title: "Patient Analytics Suite",
    subtitle: "Practice Management",
    tag: "Popular",
    rating: "4.6",
    img: analyticsIcon,
    desc: "Analytics dashboard for tracking performance and outcomes.",
  },
];

const aiSolutions = [
  { title: "Patient Communication", icon: patientIcon },
  { title: "Diagnostic Assistance", icon: diagnosticIcon },
  { title: "Practice Management", icon: practiceIcon2 },
  { title: "Treatment Planning", icon: treatmentIcon },
  { title: "Scheduling & Automation", icon: automationIcon },
  { title: "Insurance & Billing", icon: insuranceIcon },
  { title: "Imaging & Analysis", icon: imagingIcon },
  { title: "Clinical Documentation", icon: documentationIcon },
];

/* ---------- PAGE ---------- */
export default function AISolutionsPage() {
  const [active, setActive] = useState(0);
  const intervalRef = useRef(null);
  const { profile, loading, fetchProfile } = useProfile();

  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      setActive((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 4000); // 4 seconds
  };

  const stopAutoSlide = () => {
    clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  // Profile loading check - ensure profile is loaded for logged-in users
  useEffect(() => {
    const token = localStorage.getItem('token');

    // If user is logged in but profile is not loaded yet, retry fetching
    if (token && !loading && !profile) {
      console.log('Profile not loaded, retrying...');
      fetchProfile();
    }

    // If user is logged in and profile is loaded but missing image, also retry
    if (token && !loading && profile && !profile.profile_image_url) {
      console.log('Profile image missing, retrying profile fetch...');
      fetchProfile();
    }
  }, [profile, loading, fetchProfile]);

  const prevSlide = () => {
    stopAutoSlide();
    setActive((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
    startAutoSlide();
  };

  const nextSlide = () => {
    stopAutoSlide();
    setActive((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
    startAutoSlide();
  };
  return (
    <>
      <section className="eco-home-bg-main">
        <section className="marketplace-hero">
          <div className="container hero-grid">

            {/* LEFT CONTENT */}
            <div className="hero-contents">
              <h1>
                Streamline your practice with <br />
                <span>all dental apps in one place</span>
              </h1>

              <p>
                Explore the Dentulu App Marketplace to access a complete, centralized collection of dental applications created specifically for clinicians, dental offices, hygienists, assistants, and administrative teams.
              </p>
              {/* Search Bar */}
              <MarketplaceSearch />
            </div>

            {/* RIGHT IMAGE SLIDERS */}
            <div className="hero-sliders">

              {/* COLUMN 1 */}
              <div className="slider-column slow">
                <div className="slider-track">
                  {[...appImages, ...appImages].map((img, i) => (
                    <div className="slider-card" key={`a-${i}`}>
                      <img src={img} alt="app preview" />
                    </div>
                  ))}
                </div>
              </div>

              {/* COLUMN 2 (reverse direction) */}
              <div className="slider-column slower reverse">
                <div className="slider-track">
                  {[...appImagesAlt, ...appImagesAlt].map((img, i) => (
                    <div className="slider-card" key={`b-${i}`}>
                      <img src={img} alt="app preview" />
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </section>
    {/*     <section className="subscribe-banner">
          <div className="subscribe-container">
            <div className="subscribe-left">
              <h3>Enjoy 10% off your first order</h3>
              <p>
                Subscribe to unlock early product releases, limited-time deals,
                and exclusive member perks.
              </p>
            </div>

            <div className="subscribe-right">
              <div className="subscribe-form">
                <input
                  type="email"
                  placeholder="Email Address"
                  aria-label="Email Address"
                />
                <button>Get 10% off</button>
              </div>
              <span className="privacy-text">
                We respect your data and privacy. Unsubscribe anytime.
              </span>
            </div>
          </div>
        </section> */}
        {/* ================= FEATURED APPLICATIONS ================= */}
        <section className="featured-section">
          <div className="container">
            <h2 className="section-title">Featured Applications</h2>
            <p className="section-desc">
              Discover cutting-edge AI innovations built to elevate every aspect of dental care from diagnostics and documentation to patient engagement and operations. Each solution is vetted by Dentulu’s network of dental professionals for accuracy, compliance, and seamless integration into your daily workflow.
            </p>

            <div className="apps-grid">
              {featuredApps.map((app, index) => (
                <div className="app-card" key={index}>
                  <img src={app.img} alt={app.title} className="card-icon" />
                  <div className="card-top">


                    <div className="meta">
                      <span className="rating">★ {app.rating}</span>
                      <span
                        className={`tag ${app.tag === "Top Rated" ? "top-rated" : ""
                          }`}
                      >
                        {app.tag}
                      </span>
                    </div>
                    <h4 className="card-title">{app.title}</h4>
                    <span className="card-subtitle">{app.subtitle}</span>
                    <p className="card-desc">{app.desc}</p>
                  </div>


                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ================= AI SOLUTIONS SECTION ================= */}
        <section
          className="ai-solutions-section">

          <div className="container">
            <h2 className="ai-title">
              AI Solutions for Every Dental Need
            </h2>

            <p className="ai-description">
              Discover intelligent tools tailored for every aspect of modern dentistry from diagnosis to documentation.
              Each solution in Dentulu’s marketplace is vetted for accuracy, compliance, and seamless integration,
              empowering your practice to work smarter, deliver better care, and save valuable time.
            </p>

            <div className="ai-grid">
              {aiSolutions.map((item, index) => (
                <div
                  className="ai-card"
                  key={index}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="ai-icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <h4>{item.title}</h4>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ================= COMMUNITY TESTIMONIALS ================= */}
        <section
          className="community-section"
          onMouseEnter={stopAutoSlide}
          onMouseLeave={startAutoSlide}
        >


          <div className="container">

            <h2 className="community-title">What Our Community Says</h2>
            <p className="community-subtitle">
              Hear from dental providers and developers who are part of our ecosystem
            </p>

            <img
              src={bannerImg}
              alt="testimonial banner"
              className="testimonial-banner"
            />


            {/* Testimonial Content */}
            <div className="testimonial-box">
              <p className="testimonial-text">
                “{testimonials[active].text}”
              </p>
              <h4 className="testimonial-name">
                — {testimonials[active].name}
              </h4>
              <span className="testimonial-role">
                {testimonials[active].role}
              </span>
            </div>

            {/* Controls */}
            <div className="testimonial-controls">
              <button onClick={prevSlide}>‹</button>
              <button onClick={nextSlide}>›</button>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
